import { useBingoSessionStore } from '@/shared/pinia/modules/bingo/session.store';

export const refreshBingoIdentity = async (): Promise<boolean> => {
  const sessionStore = useBingoSessionStore();

  if (!sessionStore.sessionId || !sessionStore.token) {
    return false;
  }

  // The pass has to be re-minted before the reconnect, never after: bingo-backend
  // rewrites its customer row from the pass claims on every authenticated request,
  // so reconnecting on the old pass would write the blank name straight back.
  const previousToken = sessionStore.token;
  const token = await sessionStore.refresh().catch((error) => {
    sessionStore.logError(
      `Failed to refresh bingo identity: ${JSON.stringify(error)}`
    );
    return null;
  });
  if (!token) {
    return false;
  }

  if (token === previousToken) {
    sessionStore.logError(
      'Bingo identity refresh returned the same pass, skipping reconnect'
    );
    return false;
  }

  sessionStore.requestIdentityRefresh();
  return true;
};
